import React from 'react';
import { Button } from 'grommet';
 
import { withFirebase } from '../Firebase';
 
const SignOutButton = ({ firebase }) => (
  <Button default label="Sign Out" onClick={firebase.doSignOut}/>
);
 
export default withFirebase(SignOutButton);